import React, { useEffect, useState } from 'react'
import useStore from '../../ProductStore/Store'
import styles from './styles.module.css'

function Brand () {
  const { brand, setBrand, isQueryLoading } = useStore()
  const [inputValue, setInputValue] = useState(brand)

  useEffect(() => {
    const timer = setTimeout(() => {
      setBrand(inputValue)
    }, 1000) // 1000ms = 1 second

    return () => clearTimeout(timer) // Clean up the timeout if the user types again before 1 second passes
  }, [inputValue, setBrand])

  const handleInputChange = e => {
    setInputValue(e.target.value)
  }

  useEffect(() => {
    setInputValue(brand)
  }, [brand])
  

  return (
    <div className={styles.containerBrand}>
      <h1 className={styles.brandLabel}>Brand</h1>
      <input
        className={styles.inputBrand}
        type='text'
        placeholder='e.g. Samsung'
        value={inputValue}
        disabled={isQueryLoading}
        onChange={handleInputChange}
      />
    </div>
  )
}

export default Brand
